import SplashLogo from '@/assets/icons/downTime_Logomark.svg?react';
import Downtime from '@/assets/icons/hero_error.svg?react';

export default function DownTimeScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-between p-6 text-center">
      <div className="mt-8">
        <SplashLogo />
      </div>
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center">
        <Downtime className="h-auto w-full max-w-md opacity-70" />
      </div>
      <div className="">
        <p className="mt-6 text-2xl font-bold">We've run into an issue</p>
        <p className="mt-4 opacity-70">
          The app isn't loading correctly, but we're aware of the issue and working to fix it.
        </p>
        <p className="mt-4 opacity-70">For more assistance, visit:</p>
        <a href={'https://policy.enrichnetwork.io/#contact'} target={'_blank'}>
          <p className="text-primary mt-1">policy.enrichnetwork.io/#contact</p>
        </a>
      </div>
    </div>
  );
}
